var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedium = function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "regular",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.2,94.3l55.4,36.4v231.8L4.8,419.7c-10.2,10-3,27.4,11.2,27.4h125.2c14.2,0,21.4-17.3,11.2-27.4l-57.9-57.1 V193.8C153.9,320,211.8,442.8,210.4,440c5.8,11.9,24.3,12.2,29.4-1.6l0,0c0,0,0,0,0,0c13.9-38.3,43.6-120.3,41.7-115.1 c1.1-3,51.6-147.3,52.4-149.6v208.5l-37.1,37.7c-10,10.1-2.8,27.2,11.4,27.2H496c14.1,0,21.3-17,11.4-27.2l-35.7-36.5l-1.4-254.6 l36.9-36.4c10.2-10,3-27.4-11.2-27.4c-15,0,54.3,0-146.6,0.1c-20.4,0.6-13.5,19-85,208.5l-87.7-199c-2.6-5.8-8.3-9.6-14.7-9.6H16 C0.2,65-6,85.7,7.2,94.3L7.2,94.3z M55,415.1l23.6-23.3l23.6,23.3H55z M365.9,97H457c-10.2,11.4-18.8,14.7-18.8,25.3l1.5,267.8 c0,10.2,8.3,13.7,18.2,25.1H346.4c11-12.5,19.5-16,19.5-26.3L365.9,97L365.9,97z M151.6,97l97.2,220.5L222.6,391 C90.9,111.2,95.5,106.8,69.4,97L151.6,97z"
  })));
};
export default SvgMedium;